// バックエンドの packages/apis/src/utils/emailValidator.ts と同じメールアドレス判定ルールを使用する。
const EMAIL_PATTERN = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email: string): boolean => {
  if (typeof email !== "string") {
    return false;
  }

  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    return false;
  }

  return EMAIL_PATTERN.test(trimmedEmail);
};
